import { Divider, Stack } from '@mui/material';

import { Text, api } from 'common';

import { BlockDurationField } from '../../../ConfigFields/Duration';
import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';
import { FilterAndSortBlockFormFields } from '../FilterAndSortFormFields';
const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const LabValuesVariant = {
  schema: PatientDataStore.LabValuesConfigSchema,
  Config: () => {
    const { setValue: setEncounters } = useSelectedNodeField('config.encounters');
    return (
      <Stack spacing={2}>
        <Text variant="heading5" bold>
          Lab Value Filters
        </Text>
        <ParentBlockSelectField
          fieldName="config.encounters.sourceBlockName"
          label="Encounters Source"
          helperText={getSourceBlockNameHelperText('encounters')}
          clearable
          onClear={() => setEncounters(undefined)}
        />
        <BlockDurationField
          fieldName="config.labValueFilters.lookbackDuration"
          toggleLabel="Filter by Lab Value date"
          valueLabel="Only fetch lab values within last"
          unitFieldNameSuffix="units"
          required={false}
          allowedUnits={[...PatientDataStore.DURATION_UNIT_OPTIONS]}
        />
        <Divider sx={{ marginY: 2 }} />
        <FilterAndSortBlockFormFields />
      </Stack>
    );
  },
};
